import { useMemo } from 'react';

import type { SourcePlatform } from '~entities/import-job/api/types';

import { scoreCsvAgainstPlatform } from './csv-platform-match';

/** Platforms that accept any structure, so a mismatch warning would be noise. */
const UNSCORED_PLATFORMS: ReadonlyArray<SourcePlatform> = ['csv'];

interface PlatformMismatchWarningProps {
  sourcePlatform: SourcePlatform;
  uploadedHeaders: Array<string>;
  expectedHeaders: Array<string>;
  /** e.g. "class" or "family", used in the copy. */
  datasetLabel: string;
}

export function PlatformMismatchWarning({
  sourcePlatform,
  uploadedHeaders,
  expectedHeaders,
  datasetLabel,
}: PlatformMismatchWarningProps) {
  const match = useMemo(
    () => scoreCsvAgainstPlatform(uploadedHeaders, expectedHeaders),
    [uploadedHeaders, expectedHeaders],
  );

  if (UNSCORED_PLATFORMS.includes(sourcePlatform)) return null;
  if (!match.isLikelyMismatch) return null;

  return (
    <div className='rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900'>
      This {datasetLabel} file does not look like a typical{' '}
      <span className='font-medium'>{sourcePlatform}</span> export — most of the
      expected columns are missing. Double-check you selected the right platform
      and uploaded the correct file. You can still continue and map the columns
      manually.
    </div>
  );
}
